import { gql } from '@apollo/client';
import { CASE_FIELD_CONFIGURATION_FIELDS } from '../queries/CaseFieldConfigurationQueries';

// Saves the Case Details / Case Summary field selection. Rejected server-side for non-admins, for a
// locked field being switched off, and — unless confirmSummaryCascade is set — when a Summary field
// would lose the Case Details field it depends on.
export const UPSERT_CASE_FIELD_SETTINGS = gql`
  mutation upsertCaseFieldSettings($input: UpsertCaseFieldSettingsInput!) {
    configuration: upsertCaseFieldSettings(input: $input) {
      ...CaseFieldConfigurationFields
    }
  }
  ${CASE_FIELD_CONFIGURATION_FIELDS}
`;

export const UPSERT_CASE_CUSTOM_FIELD = gql`
  mutation upsertCaseCustomField($input: UpsertCaseCustomFieldInput!) {
    configuration: upsertCaseCustomField(input: $input) {
      ...CaseFieldConfigurationFields
    }
  }
  ${CASE_FIELD_CONFIGURATION_FIELDS}
`;

export const ARCHIVE_CASE_CUSTOM_FIELD = gql`
  mutation archiveCaseCustomField($id: ID!) {
    configuration: archiveCaseCustomField(id: $id) {
      ...CaseFieldConfigurationFields
    }
  }
  ${CASE_FIELD_CONFIGURATION_FIELDS}
`;
